import moment from "moment";
import { useFormikContext } from "formik";
import { FC, SetStateAction, useContext, useEffect, useRef, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { AppContext } from "../../../../../appContext/AppContext";
import AutocompleteObjectV2 from "../../../../../component/AutocompleteObjectV2";
import LabelRequired from "../../../../../component/LabelRequired";
import TextField from "../../../../../component/TextField";
import { CODE, DEFAULT_PAGE_INDEX, KEY_DS_DANH_MUC_TIEP_DON, MAX_PAGE_SIZE, RESPONSE_MESSAGE, SIMPLE_CATEGORY_TYPE } from "../../../../../utils/Constant";
import { QuanLyHopDongContext, QuanLyHopDongContextProps } from "../../../../components/tab-quan-ly-hop-dong/QuanLyHopDong";
import { getByIdNhanVien, getDanhSachCategoriService, getListGoiKhamDichVu } from "../../../../services/KhamDoanHopDongServices";
import { AddNhanVien } from "./models/ThemNhanVienModel";
import "../QuanLyHopDong.scss";
import TableTienSuBanThan from "../../../tab-kham-lam-sang/tab-kham-benh/TableTienSuBanThan";
import { IDanhSachDanhMuc } from "../../../../../phan-he-tiep-nhan-thanh-toan/models/TiepDonModel";
import DatePickerCustom from "../../../../../component/date-picker/DatePickerCustom";
import InputCellGroup from "../../../../../component/input-cell-group";
import useIndexDBValue from "../../../../../../hook/useIndexDBValue";
import { calculateAge } from "../../../../../utils/FormatUtils";

type Props = {
    thongTinHD: any;
    dataTienSuBanThan: any;
    setDataTienSuBanThan: SetStateAction<any>;
};

const FormThemMoiNhanVien: FC<Props> = (props) => {
    const { thongTinHD, dataTienSuBanThan, setDataTienSuBanThan } = props;
    const { setIsLoading } = useContext(AppContext);
    const { isClickOpenEditNV, dataEditNV, TTHopDong } =
		useContext<QuanLyHopDongContextProps>(QuanLyHopDongContext);
    const { setValues, setFieldValue, values, errors, touched, setFieldTouched } =
		useFormikContext<AddNhanVien>();
    const { value } = useIndexDBValue<IDanhSachDanhMuc>({
        key: KEY_DS_DANH_MUC_TIEP_DON,
    });

    const [dsGoiKham, setDsGoiKham] = useState<any>([]);
    const [showTableTienSuBanThan, setShowTableTienSuBanThan] = useState<boolean>(false);

    const age = calculateAge(values.dobDay, values.dobMonth, values.dobYear);

    useEffect(() => {
        isClickOpenEditNV && handlerEditNhanVien(dataEditNV)
    }, [isClickOpenEditNV]);

    useEffect(() => {
        TTHopDong?.id && getDanhSachGoiKham();
    }, [thongTinHD?.id]);

    const getDanhSachGoiKham = async (params?: any) => {
		try {
			const searchObject = {
				pageIndex: DEFAULT_PAGE_INDEX,
				pageSize: MAX_PAGE_SIZE,
				contractId: TTHopDong?.id,
				isIncludeTerms: false,
				...params,
			};

			const { data } = await getListGoiKhamDichVu(searchObject);

			if (CODE.SUCCESS === data?.code) {
				setDsGoiKham(data?.data?.content || []);
			}
		} catch(err) {
            console.log(err);
			toast.error(RESPONSE_MESSAGE.ERROR);
		}
	};

    const handlerEditNhanVien = async (value: any) => {
        try {
            const { data } = await getByIdNhanVien(value?.id);
            if (CODE.SUCCESS === data?.code) {
                let resultData = data?.data
                resultData = {
                    ...data?.data,
                    maritalStatus: {
                        id: data?.data?.maritalStatusId,
                        name: data?.data?.maritalStatusName
                    },
                    division: {
                        id: data?.data?.divisionId,
                        name: data?.data?.divisionName
                    },
                    genderObj: {
                        id: data?.data?.genderId,
                        name: data?.data?.gender
                    },
                    group: {
                        id: data?.data?.groupId,
                        name: data?.data?.groupName
                    },
                    examPackage: {
                        id: data?.data?.examPackageId,
                        name: data?.data?.examPackageName
                    },

                }
                setDataTienSuBanThan(resultData.personalMedicals || []);
                setValues({
                    ...resultData,
                    medicalHistoryFamily: resultData?.obs?.familyMedicalHistory || resultData?.medicalHistoryFamily,
                    medicalHistory:  resultData?.obs?.medicalHistory || resultData?.medicalHistory,
                });
            } else {
            }
        } catch (error) {
            setIsLoading(false);
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    const handleChangeVisit = (name: string, value: any) => {
        value && setFieldValue(name, value);
    };

    const handleSubmitTable = (values: any) => {
        const newValues = values?.filter((item: any) => 
            item.diseaseName ||
            item.discoveryYear || 
            item.occDiseaseName || 
            item.occDiscoveryYear
        );
        setDataTienSuBanThan(newValues);
        setShowTableTienSuBanThan(false);
    };

    const tienSuBenhString = dataTienSuBanThan.map((item: any) => 
        [item.diseaseName, item.discoveryYear, item.occDiseaseName, item.occDiscoveryYear]
          .filter(value => value !== null && value !== undefined)
          .join(' - ')
      ).join('; ');

    return (
		<div className="d-flex">
			<div className="border-right-0 border-left-0 border-top-0 spaces">
				<Row className="mx-0 pl-0">
					<Row className="mb-5">
						<Col xs="3">
							<TextField
								label="Mã bệnh nhân"
								name="patientCode"
								disabled
								labelClassName="min-w-150px"
							/>
						</Col>
						<Col xs="3">
							<TextField label={<div>Mã nhân viên</div>} name="code" />
						</Col>
					</Row>

					<Row className="mb-5">
						<Col lg={6}>
							<TextField
								label={
									<div>
										Tên nhân viên
										<span className="text-danger">(*)</span>
									</div>
								}
								name="name"
								labelClassName="min-w-150px"
							/>
						</Col>
						<Col lg={4} className="d-flex">
							<LabelRequired label="Ngày sinh" isRequired className="min-w-100px" />
							<div className="d-flex align-items-center">
								<InputCellGroup
									cells={[
										{
											name: 'dobDay',
											length: 2,
										},
										{
											name: 'dobMonth',
											length: 2,
										},
										{
											name: 'dobYear',
											length: 4,
										},
									]}
									value={values}
									onChange={(e) => {
										setFieldValue(e.target.name, e.target.value);
									}}
									errors={errors}
									touched={touched}
									setFieldTouched={setFieldTouched}
									inputClassName="customs-input"
								/>
								<span className="mx-2 fw-bold"> - </span>
								<TextField
									name="age"
									className="spaces w-80"
									inputClassName="w-100 text-center"
									disabled
									value={age}
								/>
							</div>
						</Col>
					</Row>

					<Row className="mb-5">
						<Col className="d-flex">
							<LabelRequired isRequired label="Giới tính" className="min-w-150px" />
							<AutocompleteObjectV2
								options={value?.listGioiTinh || []}
								value={values?.genderObj || ''}
								name="genderObj"
								onChange={(selectedOption) => {
									handleChangeVisit('genderObj', selectedOption);
									setFieldValue('examPackage', null);
									getDanhSachGoiKham({
										gender: selectedOption.name,
									});
								}}
								touched={touched?.genderObj}
								errors={errors?.genderObj}
								isClearable={false}
								className="spaces h-29 autocomplete-custom-tiep-nhan"
							/>
						</Col>
						<Col className="d-flex">
							<LabelRequired className="min-w-150px" label="Tình trạng hôn nhân" />
							<AutocompleteObjectV2
								name="maritalStatus"
								value={values?.maritalStatus || ''}
								onChange={(selectedOption) =>
									handleChangeVisit('maritalStatus', selectedOption)
								}
								isClearable={false}
								className="spaces autocomplete-custom-tiep-nhan h-29"
								searchFunction={getDanhSachCategoriService}
								searchObject={{
									pageIndex: DEFAULT_PAGE_INDEX,
									pageSize: MAX_PAGE_SIZE,
									type: SIMPLE_CATEGORY_TYPE.TINH_TRANG_HON_NHAN,
								}}
								urlData="data.data.content"
								options={[]}
							/>
						</Col>
						<Col>
							<TextField
								label={<div>Số điện thoại</div>}
								type="number"
								name="phone"
								labelClassName="min-w-150px"
							/>
						</Col>
					</Row>

					<Row className="mb-5">
						<Col xs="4">
							<TextField
								label="Số CMND/CCCD"
								name="idNumber"
								labelClassName="min-w-150px"
							/>
						</Col>
						<Col xs="4">
							<DatePickerCustom
								label="Ngày cấp"
								name="issuingDate"
								labelClassName="min-w-150px"
								value={values?.issuingDate}
								setDateValue={(date) => {
									setFieldValue('issuingDate', date);
								}}
								errors={errors?.issuingDate}
								touched={touched?.issuingDate}
								maxDate={new Date()}
							/>
						</Col>
						<Col xs="4">
							<TextField
								label="Nơi cấp"
								name="issuingPlace"
								value={values?.issuingPlace || ''}
								labelClassName="min-w-150px"
							/>
						</Col>
					</Row>

					<Row className="mb-5">
						<Col>
							<TextField
								label="Nghề nghiệp"
								name="occupation"
								labelClassName="min-w-150px"
							/>
						</Col>
						<Col>
							<DatePickerCustom
								label="Ngày bắt đầu làm việc"
								name="workStartDate"
								value={values?.workStartDate}
								setDateValue={(date) => {
									setFieldValue('workStartDate', date);
								}}
								errors={errors?.workStartDate}
								touched={touched?.workStartDate}
								labelClassName="min-w-150px"
							/>
						</Col>
						<Col>
							<TextField
								label="Công việc trước đây"
								name="preWork"
								labelClassName="min-w-150px"
							/>
						</Col>
					</Row>

					<Row className="mb-5">
						<Col>
							<TextField
								label="Địa chỉ"
								name="address"
								labelClassName="min-w-150px"
							/>
						</Col>
						<Col>
							<TextField
								label="Hộ khẩu thường trú"
								name="addressPermanent"
								labelClassName="min-w-150px"
							/>
						</Col>
					</Row>

					<Row className="mb-5">
						<Col>
							<TextField
								label={<div className="mb-10">Tiền sử bệnh</div>}
								name="medicalHistory"
								className="min-height-60px"
								as="textarea"
								value={values?.medicalHistory || ''}
								labelClassName="min-w-150px"
							/>
						</Col>
						<Col>
							<TextField
								label={<div className="mb-10">Tiền sử gia đình</div>}
								name="medicalHistoryFamily"
								className="min-height-60px"
								as="textarea"
								value={values?.medicalHistoryFamily || ''}
								labelClassName="min-w-150px"
							/>
						</Col>
					</Row>

                    <Row className="mb-5">
						<Col>
							<div className="position-relative">
								<TextField
									className="cursor-pointer"
									label="Tiền sử bệnh bản thân"
									name="employeeMedicalHistory"
									value={tienSuBenhString}
									inputClassName="spaces pr-24"
									readOnly={true}
									onClick={(e: any) => setShowTableTienSuBanThan(true)}
									labelClassName="min-w-150px"
								/>
								<i
									onClick={(e: any) => setShowTableTienSuBanThan(true)}
									className="bi bi-three-dots custom-icon-text-field cursor-pointer"
								></i>
							</div>
						</Col>
					</Row>

					<Row className="mb-5">
						<Col xs="6" className="d-flex">
							<LabelRequired isRequired className="min-w-150px" label="Gói khám" />
							<AutocompleteObjectV2
								options={dsGoiKham || []}
								value={values?.examPackage || ''}
								name="examPackage"
								onChange={(selectedOption) =>
									handleChangeVisit('examPackage', selectedOption)
								}
								touched={touched?.examPackage}
								errors={errors?.examPackage}
								isClearable={false}
								className="spaces h-29 autocomplete-custom-tiep-nhan"
								dependencies={[dsGoiKham]}
							/>
						</Col>
						<Col xs="4">
							<DatePickerCustom
								label="Ngày khám dự kiến"
								required
								name="examExpectedDate"
								value={values?.examExpectedDate}
								setDateValue={(date) => {
									setFieldValue('examExpectedDate', date);
								}}
								errors={errors?.examExpectedDate}
								touched={touched?.examExpectedDate}
								labelClassName="min-w-150px"
							/>
						</Col>
					</Row>
				</Row>
			</div>

			{showTableTienSuBanThan && (
				<Modal
					centered
					show={showTableTienSuBanThan}
					size="xl"
					onHide={() => setShowTableTienSuBanThan(false)}
				>
					<Modal.Header closeButton>
						<h4 className="text-title-kls fw-bold fs-5">Tiền sử bệnh bản thân</h4>
					</Modal.Header>
					<div className="spaces px-10">
						<TableTienSuBanThan
							independentForm={true}
							data={dataTienSuBanThan}
							height={300}
							onSubmit={handleSubmitTable}
							onHide={() => setShowTableTienSuBanThan(false)}
						/>
					</div>
				</Modal>
			)}
		</div>
	);
};
export default FormThemMoiNhanVien;

